import { DefaultUrlSerializer, UrlTree } from '@angular/router';

const SUPPORTED_LANGS: ReadonlySet<string> = new Set(['fr', 'en', 'es', 'it', 'de', 'pt', 'nl', 'pl', 'ro']);
const STORAGE_KEY = 'ancelade_lang';

function activeLang(): string {
  if (typeof document !== 'undefined') {
    const docLang = document.documentElement.lang;
    if (SUPPORTED_LANGS.has(docLang)) {
      return docLang;
    }
  }
  if (typeof localStorage !== 'undefined') {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored !== null && SUPPORTED_LANGS.has(stored)) {
      return stored;
    }
  }
  return 'fr';
}

/**
 * Préfixe la langue active sur toute URL générée sans segment de langue.
 *
 * Les templates écrivent des liens neutres (`routerLink="/vps-standard"`) :
 * sans ce sérialiseur, le href rendu est `/vps-standard` et une ouverture
 * hors navigation Angular (clic molette, nouvel onglet, partage) repasse par
 * la détection de langue — l'utilisateur peut changer de langue sans l'avoir
 * demandé. Ici le href rendu est `/fr/vps-standard` : la langue ne change
 * que via le sélecteur. `parse()` reste celui d'Angular, le guard `:lang`
 * continue de gérer les URLs legacy sans préfixe.
 */
export class LangUrlSerializer extends DefaultUrlSerializer {
  override serialize(tree: UrlTree): string {
    const url = super.serialize(tree);
    const delim = url.search(/[?#]/);
    const path = delim === -1 ? url : url.slice(0, delim);
    const suffix = delim === -1 ? '' : url.slice(delim);

    const first = path.split('/').find((segment) => segment !== '');
    if (first !== undefined && SUPPORTED_LANGS.has(first)) {
      return url;
    }

    const lang = activeLang();
    return path === '/' || path === '' ? `/${suffix}` : `/${lang}${path}${suffix}`;
  }
}
